export default function (size) {
    const units = ["o", "Ko", "Mo", "Go", "To"];
    for (let idx = 0; idx < 5; idx++) {
        if (size < 1024 || idx === 4) {
            return `${size.toFixed(2)} ${units[idx]}`;
        }
        size /= 1024;
    }
}
